import { apiEndPoint } from '../../../services/endpoint';
import { UserService } from './UserService';
import { CommonService } from './CommonService';

export const userService = new UserService(apiEndPoint);
export const commonService = new CommonService(apiEndPoint);
